<template>
  <div class="tab-wrapper">
    <f7-segmented style="padding: 5px 15px;">
      <f7-button v-for="(tab, index) in tabs" :key="tab.tabPosition" :tab-link="'#tab-'+tabId(tab.tabPosition)" :tab-link-active="index==0">
        {{tab.tabLabel}}
      </f7-button>
    </f7-segmented>
    <f7-tabs class="ql-editor">
      <f7-tab v-for="(tab, index) in tabs" :key="tab.tabPosition" :id="'tab-'+tabId(tab.tabPosition)" :tab-active="index==0" v-html="tab.content"></f7-tab>
    </f7-tabs>
  </div>
</template>
<script>
import kebabcase from 'lodash.kebabcase'
import { getRandomInt } from '@/modules/helper/index'
export default {
  props: {
    tabs: {
      type: Array,
      default: []
    }
  },
  computed: {
    randomNo() {
      return getRandomInt()
    }
  },
  methods: {
    tabId: function(value) {
      return kebabcase(value) + '' + this.randomNo
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/stacked-elements/content-control/Tab.vue